/* eslint-disable react-hooks/rules-of-hooks */
import { useContext, useEffect, useState } from 'react';
import MainContext from '../../Context';
import { getValues } from '../../xform';
import usePaymentFlowMachine from './usePaymentFlowMachine';
const useFormValues = () => {
    /* Begin Hack */
    /*
     * This block of code (and the resulting eslint disable below) is only useful
     * to allow us to test our code while mocking form states without having to go
     * through the form
     */
    const { defaultFormState } = useContext(MainContext);
    /* istanbul ignore next */
    if (process.env.NODE_ENV !== 'test' && defaultFormState) {
        throw new Error(`'defaultFormState' should not be set`);
    }
    if (defaultFormState) {
        return defaultFormState;
    }
    /* End Hack */
    const [, paymentFlowActor] = usePaymentFlowMachine();
    const formActorRef = paymentFlowActor.context.form;
    const fieldActors = formActorRef === null || formActorRef === void 0 ? void 0 : formActorRef.getSnapshot().context.actors;
    const [subscriptions, setSubscriptions] = useState([]);
    const [values, setValues] = useState(getValues(fieldActors));
    useEffect(() => {
        subscriptions.forEach(({ unsubscribe }) => unsubscribe());
        if (fieldActors)
            setSubscriptions(Object.values(fieldActors).map((fieldActor) => fieldActor.subscribe(() => {
                setValues(getValues(fieldActors));
            })));
        return () => {
            subscriptions.forEach(({ unsubscribe }) => unsubscribe());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fieldActors]);
    return values;
};
export default useFormValues;
